import { ReactComponent as DoneCoverSvg } from 'src/assets/icons/cover-image-done.svg';
import styled from 'styled-components';

export const DoneCoverImage = styled(DoneCoverSvg)``;
